import type React from 'react';
import { Button, Divider } from 'antd';
import InfoItem from 'components/ui/info-item';
import SummarySection from 'components/ui/summary-section';
import { EditIcon } from 'assets/icons/edit';
import FileSummary from 'components/ui/file-summary';
import { SummaryData } from 'components/ui/review-summary/types';
import { useTranslation } from 'react-i18next';

interface ReviewSummaryProps {
  onEdit: () => void;
  onCancel: () => void;
  onCreate: () => void;
  summaryData: SummaryData;
  cancelText: string;
  okText: string;
}

const ReviewSummary: React.FC<ReviewSummaryProps> = ({
  onEdit,
  onCancel,
  onCreate,
  summaryData,
  okText,
  cancelText,
}) => {
  const { t } = useTranslation();
  return (
    <div className="bg-white rounded-lg shadow-[0px_4px_24px_rgba(0,_0,_0,_0.08)] w-[55%] px-20 py-8 border-[#E4E4E4] border-[1px] border-solid box-border">
      <div className="flex justify-between items-center my-4">
        <h3 className="text-2xl font-medium">{summaryData.title}</h3>
        <Button
          icon={<EditIcon />}
          type="link"
          onClick={onEdit}
          className="flex items-center gap-1 text-[#1D67B6]"
        >
          {t('general.edit')}
        </Button>
      </div>

      <Divider className="my-8" />

      {summaryData.sections.map(({ icon, title, items, fileData }, index) => (
        <SummarySection key={index} icon={icon} title={title}>
          {!fileData ? (
            items.map((item, itemIndex) => (
              <InfoItem key={itemIndex} {...item} />
            ))
          ) : (
            <div className="grid grid-cols-2 gap-2">
              {fileData.fileList.map((file) => (
                <FileSummary
                  key={file.id}
                  file={file}
                  sessionId={fileData.sessionId}
                  entityType={fileData.entityType}
                />
              ))}
            </div>
          )}
        </SummarySection>
      ))}

      <div className="flex flex-col sm:flex-row gap-2 mt-12">
        <Button
          className="w-full rounded-[12px] h-12 text-base font-medium"
          size="large"
          onClick={onCancel}
          danger
        >
          {cancelText}
        </Button>
        <Button
          className="w-full rounded-[12px] h-12 text-base font-medium"
          type="primary"
          size="large"
          onClick={onCreate}
        >
          {okText}
        </Button>
      </div>
    </div>
  );
};

export default ReviewSummary;
